exports = module.exports = require("../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".CodeMirror-fullscreen{position:fixed;top:0;left:0;right:0;bottom:0;height:auto;z-index:9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/codemirror/addon/display/fullscreen.css
// module id = 1818
// module chunks = 9